export default __webpack_public_path__ + "static/media/Conviction3_2.695c681a.png";